<template>
    <app-layout>
        <template #header>
            <FarmTitle :farm="farm">
                Allen Pferden hinzufügen
            </FarmTitle>
        </template>
        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg p-8">
                    <h1 class="text-2xl">Produkt welches hinzugefügt werden soll (Jeweils Menge)</h1>
                    <p class="text-gray-700">Das Produkt wird jeweils zum nächsten monatsersten mit dem dort vorhandenen Preis verbucht.</p>
                        <div class="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 mt-4">
                            <div class="relative flex items-start" v-for="product in products">
                                <div class="flex items-center h-5">
                                    <input :id="'product-'+product.id" v-model="form.addProduct[product.id].value" type="number" class="focus:ring-indigo-500 h-6 w-16 text-indigo-600 border-gray-300 rounded">
                                </div>
                                <div class="ml-3 text-sm">
                                    <label :for="'product-'+product.id" class="font-medium text-gray-900">{{ product.name }} ({{ product.item_number }})</label>
                                </div>
                            </div>
                        </div>
                    <button @click="form.post(route('product.prices.massAdd', farm.id))" type="button" class="mt-4 float-right inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        Massenhaft hinzufügen
                    </button>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
    import FarmTitle from "@/Layouts/FarmTitle";
    import Button from "@/Jetstream/Button";
    import HorseEdit from "@/Modules/HorseEdit";
    import AppLayout from "@/Layouts/AppLayout";
    import {ExclamationIcon, InformationCircleIcon, PlusIcon} from "@heroicons/vue/solid/esm";
    import JetInputError from "@/Jetstream/InputError";
    import JetDialogModal from "@/Jetstream/DialogModal";

    export default {
        components: {FarmTitle, Button, HorseEdit, AppLayout, ExclamationIcon, InformationCircleIcon, PlusIcon, JetInputError, JetDialogModal },
        name: "MassAdd",
        props: ['products', 'farm'],
        data() {
            return {
                form: new this.$inertia.form({
                    addProduct: []
                })
            }
        },
        created() {
            for(let product of this.products) {
                this.form.addProduct[product.id] = {
                    value: 0,
                    product_id: product.id
                }
            }
        }
    }
</script>

<style scoped>

</style>
